(function () {
  function updateScentDescription(productInfo) {
    var description = productInfo.querySelector('[data-memore-scent-description]');
    if (!description) return;

    var checked = productInfo.querySelector(
      'input[type="radio"][value="Green Tea & Bergamot"]:checked, input[type="radio"][value="Wild Pear & Freesia"]:checked, input[type="radio"][value="Neroli & Jasmine"]:checked'
    );
    var values = {
      'Green Tea & Bergamot': description.dataset.descriptionGreenTea || '',
      'Wild Pear & Freesia': description.dataset.descriptionWildPear || '',
      'Neroli & Jasmine': description.dataset.descriptionNeroli || ''
    };
    var nextValue = checked ? values[checked.value] || '' : '';

    if (description.textContent.trim() !== nextValue) {
      description.textContent = nextValue;
    }
  }

  function initializeScentDescription(scope) {
    var descriptions = scope.querySelectorAll('[data-memore-scent-description]');

    descriptions.forEach(function (description) {
      var productInfo = description.closest('product-info') || document;

      if (productInfo !== document && productInfo.dataset.memoreScentObserverBound !== 'true') {
        var observer = new MutationObserver(function () {
          updateScentDescription(productInfo);
        });

        observer.observe(productInfo, { childList: true, subtree: true });
        productInfo.dataset.memoreScentObserverBound = 'true';
      }

      updateScentDescription(productInfo);
    });
  }

  function handleScentChange(event) {
    var input = event.target;

    if (
      !input.matches(
        'input[type="radio"][value="Green Tea & Bergamot"], input[type="radio"][value="Wild Pear & Freesia"], input[type="radio"][value="Neroli & Jasmine"]'
      )
    ) {
      return;
    }

    var productInfo = input.closest('product-info') || document;
    updateScentDescription(productInfo);

    window.setTimeout(function () {
      updateScentDescription(productInfo);
    }, 250);
  }

  function initializeStickyCart(scope) {
    var bars = scope.querySelectorAll('[data-memore-mobile-sticky-atc]');

    bars.forEach(function (bar) {
      if (bar.dataset.memoreBound === 'true') return;

      var mainButton = document.getElementById(bar.dataset.mainButtonId || '');
      var dateSelector = document.getElementById(bar.dataset.dateSelectorId || '');
      var stickyButton = bar.querySelector('.memore-mobile-sticky-atc__button');
      var productForm = mainButton ? mainButton.closest('form') : null;
      var footer = document.querySelector('footer.footer') || document.querySelector('footer');
      var mobileQuery = window.matchMedia('(max-width: 749px)');
      var pastMainButton = false;
      var footerVisible = false;

      if (!mainButton || !stickyButton) return;

      if (bar.parentElement !== document.body) {
        document.body.appendChild(bar);
      }

      function syncButtonState() {
        stickyButton.disabled = mainButton.disabled;
        stickyButton.setAttribute('aria-disabled', mainButton.disabled ? 'true' : 'false');
      }

      function updateVisibility() {
        var shouldShow = mobileQuery.matches && pastMainButton && !footerVisible;
        bar.hidden = !mobileQuery.matches;
        bar.classList.toggle('is-visible', shouldShow);
        bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }

      var buttonObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            pastMainButton = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          });
          updateVisibility();
        },
        { threshold: 0 }
      );

      buttonObserver.observe(mainButton);

      if (footer) {
        var footerObserver = new IntersectionObserver(
          function (entries) {
            footerVisible = entries.some(function (entry) {
              return entry.isIntersecting;
            });
            updateVisibility();
          },
          { threshold: 0 }
        );
        footerObserver.observe(footer);
      }

      var stateObserver = new MutationObserver(syncButtonState);
      stateObserver.observe(mainButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });

      stickyButton.addEventListener('click', function () {
        var selectedDate = productForm
          ? productForm.querySelector('input[name="properties[Selected Date]"]')
          : null;

        if (!selectedDate || !selectedDate.value.trim()) {
          if (dateSelector) {
            var hint = dateSelector.querySelector('#memoreHint');
            var targetTop = window.scrollY + dateSelector.getBoundingClientRect().top - 96;

            if (hint) {
              hint.classList.remove('is-hidden');
              hint.style.color = '#a33a32';
              hint.textContent = 'Please select a date before adding to cart.';

              window.setTimeout(function () {
                hint.style.color = '';
                hint.textContent = 'Choose a date to reveal its bloom.';
              }, 3000);
            }

            window.scrollTo({
              top: Math.max(0, targetTop),
              behavior: 'smooth'
            });

            var month = dateSelector.querySelector('#memoreMonth');
            if (month) {
              window.setTimeout(function () {
                month.focus({ preventScroll: true });
              }, 350);
            }
          }
          return;
        }

        mainButton.click();
      });

      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', updateVisibility);
      } else {
        mobileQuery.addListener(updateVisibility);
      }

      bar.dataset.memoreBound = 'true';
      syncButtonState();
      updateVisibility();
    });
  }

  function initialize(scope) {
    initializeScentDescription(scope);
    initializeStickyCart(scope);
  }

  function boot() {
    initialize(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('change', handleScentChange);

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
